import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';

import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import CamperService from '../../api/services/CamperService';
import AdminDatesService from '../../api/services/AdminDatesService';
const MinimumRentDurationList = () => {
    const [Error, setError] = useState('');

    const navigate = useNavigate();
    const [camper, setCamper] = useState([]);
    const [MinimumRentList, setMinimumRentList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setisloading] = useState(true);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = MinimumRentList.slice(firstIndex, lastIndex);
    const npage = Math.ceil(MinimumRentList.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)

    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage(id) {
        setCurrentPage(id);
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const getMinimumRentList = async () => {

        try {
            setisloading(true);
            let responseData = await AdminDatesService.index().json()
            setMinimumRentList(responseData.data)
            let camper = await CamperService.index().json();

            var camperdata = camper.data.filter(function (item) {
                return item.camper_type_id == 1 && item.status == 1
            });
            setCamper(camperdata);
            setisloading(false);
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
           
            getMinimumRentList();
        }
        else {
            navigate('/')
        }
    }, []);

    const handledeletefunction = (id) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this data!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {

                let responseData = await AdminDatesService.destroy(id).json()
                if (responseData.status === true) {
                    getMinimumRentList();
                }
                swal("Your Minimum Rent Duration has been deleted successfully!", {
                    icon: "success",
                });
            }
        }).catch(() => {
            swal("Your Restricted Date is safe!");
        });
    }
    if (isLoading) {
        return <LogoAnimationLoader />;  // Placeholder or loading spinner
    }
    return (
        <>
            <MainPagetitle mainTitle="Minimum Rent Durations" pageTitle={'Minimum Rent Durations'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0"> Minimum Rent Durations</h4>
                                        <div>
                                            <Link to={`/admin/add-minimumrentduration/`} className="btn btn-primary btn-sm ms-1">+ Add Minimum Rent Duration</Link> {" "}
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th >
                                                        <strong>No.</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Start Date</strong>
                                                    </th>
                                                    <th>
                                                        <strong>End Date</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Minimum Rent Duration</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Affected Vehicles </strong>
                                                    </th>

                                                    <th style={{ textAlign: 'left' }}><strong>Action</strong></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    records.map((element, index) => {

                                                        return (
                                                            <tr style={{ textAlign: 'center' }}>
                                                                <td>
                                                                    {index + 1}
                                                                </td>
                                                                <td>
                                                                    {element.start_date}

                                                                </td>
                                                                <td>
                                                                    {element.end_date}
                                                                </td>
                                                                <td>
                                                                    {element.minimum_rent_duration}
                                                                </td>
                                                                <td style={{ whiteSpace: 'pre-line' }}>

                                                                    {element.camper_title ?
                                                                        camper.length === element.camper_title.length ?
                                                                            "All Vehicles" :
                                                                            element.camper_title.map((title, index) =>
                                                                                index === element.camper_title.length - 1 ? title : title + ", "
                                                                            ).join('')
                                                                        : ""
                                                                    }
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex">
                                                                        <Link
                                                                            to={`/admin/edit-minimumrentduration/${element.id}`}
                                                                            className="btn btn-primary shadow btn-xs sharp me-1"
                                                                        >
                                                                            <i className="fas fa-pencil-alt"></i>
                                                                        </Link>
                                                                        <Link className="btn btn-danger shadow btn-xs sharp" onClick={() => handledeletefunction(element.id)}
                                                                        >
                                                                            <i className="fa fa-trash"></i>
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>

                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {MinimumRentList.length < lastIndex ? MinimumRentList.length : lastIndex}
                                                {" "}of {MinimumRentList.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default MinimumRentDurationList;
